import { types } from './actions';

const initialState = {
  areMultiOrgSettingsSaving: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_DEFAULT_ORGANIZATION_REQUEST:
      return {
        ...state,
        areMultiOrgSettingsSaving: true,
      };
    case types.UPDATE_DEFAULT_ORGANIZATION_SUCCESS:
    case types.UPDATE_DEFAULT_ORGANIZATION_ERROR:
      return {
        ...state,
        areMultiOrgSettingsSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.userProfile.multiOrgSettings;

export const areMultiOrgSettingsSaving = (state) =>
  getScope(state)?.areMultiOrgSettingsSaving || false;
